import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-success-response',
    imports: [],
    templateUrl: './success-response.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './success-response.component.scss',
})
export class SuccessResponseComponent {}
